const initializeAccordion = () => {
    const accordionClick = document.querySelectorAll('.js-accordion-click');
    accordionClick &&
        accordionClick.forEach((item) => {
            item.addEventListener('click', () => {
                const accordionItem = item.closest('.js-accordion-item');
                const accordionParent = item.closest('.js-accordion-parent');
                if (accordionItem === null || accordionItem === void 0 ? void 0 : accordionItem.classList.contains('active')) {
                    accordionItem === null || accordionItem === void 0 ? void 0 : accordionItem.classList.remove('active');
                }
                else {
                    const activeAccordion = accordionParent === null || accordionParent === void 0 ? void 0 : accordionParent.querySelector('.js-accordion-item.active');
                    activeAccordion === null || activeAccordion === void 0 ? void 0 : activeAccordion.classList.remove('active');
                    accordionItem === null || accordionItem === void 0 ? void 0 : accordionItem.classList.add('active');
                }
            });
        });
};
export default initializeAccordion;
